module.exports = __webpack_public_path__ + "static/media/check-material.5fab220b.svg";